import React from 'react';
import Teaser from 'components/teaser';
import PropTypes from 'prop-types';

const ProductFeaturesAndTechnology = ({ blocks }) =>
  blocks && blocks.length > 0 ? (
    <div className="product-features-and-technology">
      {blocks.map((block, index) => (
        <div className="product-features-and-technology__col" key={index}>
          <Teaser {...block} />
        </div>
      ))}
    </div>
  ) : null;

ProductFeaturesAndTechnology.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  title: PropTypes.string,
  blocks: PropTypes.arrayOf(PropTypes.exact(Teaser.propTypes))
};

export default ProductFeaturesAndTechnology;
